import { render, staticRenderFns } from "./StatSection.vue?vue&type=template&id=2e5bbb5d&scoped=true&"
import script from "./StatSection.vue?vue&type=script&lang=js&"
export * from "./StatSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5bbb5d",
  null
  
)

export default component.exports